export { DialogCard } from './DialogCard';
export type { DialogCardProps, DialogCardMode } from './DialogCard';
